'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dyzioModal = require('../dyzio-modal');

var _dyzioModal2 = _interopRequireDefault(_dyzioModal);

var _demographicsLocationTable = require('../demographics-location-table');

var _demographicsLocationTable2 = _interopRequireDefault(_demographicsLocationTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullCountryModal = function FullCountryModal(_ref) {
  var onToggle = _ref.onToggle,
      audienceLocations = _ref.audienceLocations;
  return _react2.default.createElement(
    _dyzioModal2.default,
    {
      headerText: 'Followers by Country',
      size: 'small',
      onClose: onToggle,
      hasCloseButton: true
    },
    _react2.default.createElement(_demographicsLocationTable2.default, {
      data: audienceLocations.data,
      metric: 'absolute',
      metricLabel: 'Followers',
      itemLabel: 'Country',
      uniqueKey: 'location',
      rowsToShow: -1
    })
  );
};

FullCountryModal.propTypes = {
  onToggle: _propTypes2.default.func.isRequired,
  audienceLocations: _propTypes2.default.object.isRequired
};

exports.default = FullCountryModal;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/instagram-profile-data/full-country-modal.js
 ** module id = 2594
 ** module chunks = 0
 **/